// extracted by mini-css-extract-plugin
module.exports = {"list":"e_rA","hero":"e_sA"};